import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpedienteService } from '../../../services/expediente.service';
import { TableColumn } from '../../../dto/util/table-column';
import { ExpedienteSupersociedadesDto } from '../../../dto/expediente/expediente-supersociedades.dto';
import { HistorialExpedienteSupersociedadesDto } from '../../../dto/expediente/historial-expediente-supersociedades.dto';
import { UtilService } from '../../../services/util.service';
import moment from 'moment';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { TranslateService } from '@ngx-translate/core';
import { EntidadService } from "../../../services/entidad.service";
import { EntidadApiResponse } from "../../../dto/entidad/entidad-response.dto";
import { Constants } from '../../../constants/constants';
import { Entidades } from '../../../constants/entidades.constants';
import { DescargaDocumentosComponent } from '../descarga-documentos/descarga-documentos.component';
import { ModalService } from '../../../services/util/modal.service';

@Component({
  selector: 'app-detalle-supersociedades',
  templateUrl: './detalle-supersociedades.component.html',
  styleUrl: './detalle-supersociedades.component.scss',
})
export class DetalleSupersociedadesComponent implements OnInit {
  expedienteSupersociedadesDto?: ExpedienteSupersociedadesDto;
  historialExpediente: HistorialExpedienteSupersociedadesDto[] = [];
  idExpediente = 0;
  usuarioCreadorId = 0;
  entidadId = 1;
  columns: TableColumn[] = [];
  columnsInsolvencia: TableColumn[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;
  isCreator = false;
  public role = '';

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  tableText: any = {};
  guiaText: any = {};
  guiaInsolvenciaText: any = {};
  insolvenciaText: any = {};
  entidad!: EntidadApiResponse;
  tipoDocumentoUsuario = '';
  numeroIdentificacion = '';
  nombreEntidad: string = "";
  constructor(
    private route: ActivatedRoute,
    private expedienteService: ExpedienteService,
    private router: Router,
    private utilService: UtilService,
    private translate: TranslateService,
    private entidadService: EntidadService,
    private readonly modalService: ModalService,
  ) {
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }
    this.route.params.subscribe(params => {
      this.idExpediente = params['expedienteId'];
      this.usuarioCreadorId = params['usuarioId'];
    });
    // Multilenguaje
    this.translate
      .stream('detalle-superintendencia-sociedades')
      .forEach(text => {
        for (let key of Object.keys(text)) {
          this.tableText[key] = text[key];
        }
        this.initColumns();
      });
    this.translate.stream('guias-interactivas').subscribe(text => {
      this.guiaText = text;
      this.initColumns();
    });
    this.translate.stream('guia-supersociedades-insolvencia').subscribe(text => {
      this.guiaInsolvenciaText = text;
      this.initColumns();
    });
    this.translate.stream('supersociedades-insolvencia').subscribe(text => {
      this.insolvenciaText = text;
      this.initColumns();
    });
  }

  ngOnInit(): void {
    this.initColumns();
    this.cargarEntidad();
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tipoDocumentoUsuario = infoInicioSesion.tipoDocumento;
    this.numeroIdentificacion = infoInicioSesion.identificacion;
    this.filtradoExpediente(this.idExpediente, this.tipoDocumentoUsuario, this.numeroIdentificacion);
    this.isCreator = infoInicioSesion.idUsuario === +this.usuarioCreadorId;
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: 'Histórico de expediente',
      descripcionPantalla:
        'En esta pantalla usted podrá visualizar el expediente seleccionado de la ' +
        'Superintendencia de Sociedades',
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaInsolvenciaText['tour-titulo'],
            description:
              this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaInsolvenciaText['encabezado-titulo'],
            description: this.guiaInsolvenciaText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#id',
          popover: {
            title: 'ID',
            description: this.guiaInsolvenciaText['ID'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#deudor',
          popover: {
            title: this.insolvenciaText['deudor-solicitante'],
            description: this.guiaInsolvenciaText['deudor'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#radicado',
          popover: {
            title: this.insolvenciaText['numero-radicado'],
            description: this.guiaInsolvenciaText['radicado'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#fechaCarga',
          popover: {
            title: this.insolvenciaText['fecha-carga'],
            description: this.guiaInsolvenciaText['fecha-carga'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#fechaRadicacion',
          popover: {
            title: this.insolvenciaText['fecha-radicacion'],
            description: this.guiaInsolvenciaText['fecha-radicacion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#estado',
          popover: {
            title: this.insolvenciaText['estado'],
            description: this.guiaInsolvenciaText['estado'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#usuarioSolicitante',
          popover: {
            title: this.insolvenciaText['usuario-solicitante'],
            description: this.guiaInsolvenciaText['usuario'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#proceso',
          popover: {
            title: this.insolvenciaText['proceso'],
            description: this.guiaInsolvenciaText['proceso'],
            side: 'bottom',
            align: 'start',
          }
        }
      ]
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
  }

  filtradoExpediente(idExpediente: number, tipoDocumentoUsuario: string, numeroIdentificacion: string) {
    this.expedienteService
      .getExpedientesSupersociedades(idExpediente, tipoDocumentoUsuario, numeroIdentificacion)
      .subscribe(response => {
        this.expedienteSupersociedadesDto = response;
        this.expedienteSupersociedadesDto.fechaCreacion = moment(
          response.fechaCreacion,
          'DD/MM/YYYY'
        )
          .toDate()
          .toDateString();
        this.expedienteSupersociedadesDto.actuaciones.map(actuacion => {
          actuacion.fecha_carga_informacion = moment(
            actuacion.fecha_carga_informacion,
            'DD/MM/YYYY'
          ).toDate();
          actuacion.fecha_radicacion = moment(
            actuacion.fecha_radicacion,
            'DD/MM/YYYY'
          ).toDate();
        });
        this.expedienteSupersociedadesDto.partes?.map(parte => {

        });
        this.historialExpediente =
          this.expedienteSupersociedadesDto.actuaciones;
        this.historialExpediente = this.historialExpediente.map(historico => ({
          ...historico,
          documento: 'Ver documentos',
        }));
        this.initColumns();
      });
  }

  initColumns() {
    this.columns = [
      {
        field: 'Id',
        title: this.tableText['id'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'id',
        width: '100px',
      },
      {
        field: 'Numero_Radicado',
        title: this.tableText['radicado'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'Numero_Radicado',
      },
      {
        field: 'Fecha',
        title: this.tableText['fecha-radicacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'Fecha',
        pipe: 'dd/MM/yyyy',
      },
      {
        field: 'Tramite',
        title: this.tableText['proceso'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'Tramite',
      },
      {
        field: 'documento',
        title: this.tableText['ver'],
        type: 'text',
        filterable: false,
        sortable: false,
        accion: item => {
          this.openModal(item);
        },
      },
    ];
    this.columnsInsolvencia = [
      {
        field: 'id',
        title: this.tableText['id'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'id',
        width: '100px',
      },
      {
        id: 'deudor',
        field: 'Deudor_Solicitante',
        title: this.tableText['deudor'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'Deudor_Solicitante',
      },
      {
        id: 'radicado',
        field: 'Numero_Radicacion',
        title: this.tableText['radicado'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'Numero_Radicacion',
        width: '150px',
      },
      {
        id: 'fechaCarga',
        field: 'fecha_carga_informacion',
        title: this.tableText['fecha-carga'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'fecha_carga_informacion',
        pipe: 'dd/MM/yyyy',
      },
      {
        id: 'fechaRadicacion',
        field: 'Fecha_Radicacion',
        title: this.tableText['fecha-radicacion'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'Fecha_Radicacion',
        pipe: 'dd/MM/yyyy',
      },
      {
        id: 'estado',
        field: 'estado',
        title: this.tableText['estado'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'estado',
      },
      {
        id: 'usuarioSolicitante',
        field: 'usuario_solicitante',
        title: this.tableText['usuario'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'usuario_solicitante',
      },
      {
        id: 'proceso',
        field: 'proceso',
        title: this.tableText['proceso'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'proceso',
      },
      {
        field: 'documento',
        title: this.tableText['ver'],
        type: 'text',
        filterable: false,
        sortable: false,
        accion: item => {
          this.openModal(item);
        },
      },
      // {
      //   field: '',
      //   title: 'Opciones',
      //   type: 'text',
      // },
    ];
  }

  openModal(item: any) {
    const modalData: any = {
      ...item,
      entidadId: this.entidadId,
      expedienteId: this.idExpediente,
      numeroProceso: this.idExpediente,
      nombreEntidad: Entidades.SSOCIEDADES,
      radicado: this.expedienteSupersociedadesDto?.radicado,
      esInsolvencia: this.expedienteSupersociedadesDto?.esInsolvencia,
    };
    this.modalService.openModal(DescargaDocumentosComponent, modalData);
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    if (this.showButton) {
      this.utilService.show();
    } else {
      this.utilService.hide();
    }

    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.idExpediente}/solicitudes`,
    ]);
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }
}
